import Glide from '@glidejs/glide';

export const organizationsCarousel = () => {
    const glide = new Glide('.organizations-carousel', {
        type: 'carousel',
        perView: document.documentElement.clientWidth < 426 ? 1 : 3,
        focusAt: 'center',
    });
    glide.mount();
};
